// used for RXJS
export enum NotificationKind {
    NEXT = 'N',
    ERROR = 'E',
    COMPLETE = 'C'
}
